var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(this.$route.name !== 'login')?_c('Navbar'):_vm._e(),_c('v-main',{staticClass:"background-second",attrs:{"min-height":"80%","light":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }